import { QueryKey } from '@tanstack/react-query';
import { ReadyStateEvent, SSE } from 'sse.js';
import { queryClient } from '~/config/reactQueryConfig';

export const getEventStreamContent = <TData>(
  queryKey: QueryKey,
  url: string,
): Promise<TData> => {
  return new Promise<TData>((resolve, reject) => {
    const eventSource: SSE = new SSE(url);

    eventSource.addEventListener('message', (evt: MessageEvent<string>) => {
      const data: TData = JSON.parse(evt.data);

      if (evt.lastEventId === 'END') {
        queryClient.setQueryData(queryKey, data);
        eventSource.close();
        resolve(data);
      } else {
        if (data) {
          queryClient.setQueryData(queryKey, data);
        }
      }
    });

    eventSource.addEventListener('error', (evt: Event) => {
      eventSource.close();
      reject(evt);
    });

    eventSource.addEventListener('readystatechange', (evt: ReadyStateEvent) => {
      if (evt.readyState === 2) {
        const data = queryClient.getQueryData<TData>(queryKey);
        eventSource.close();
        resolve(data as TData);
      }
    });
  });
};
